"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storesContext = void 0;
var react_1 = __importDefault(require("react"));
var Store_1 = require("../models/Store");
exports.storesContext = react_1.default.createContext({
    rootStore: Store_1.defaultRootStore,
});
